export default __webpack_public_path__ + "static/BasierCircle-SemiBold-19cde8674c043cdf690b7787e5f1f5b6.woff";